// src/pages/UrunDetay.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './UrunDetay.css';

const UrunDetay = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [urun, setUrun] = useState(null);
  const [showGenel, setShowGenel] = useState(false);
  const [showVaryant, setShowVaryant] = useState(false);

  useEffect(() => {
    fetch('/urunler.json')
      .then(res => res.json())
      .then(veri => {
        const orijinal = veri.find(u => u.id?.toString() === id.toString());

        const bulunan = {
          ...orijinal,
          genelOzellikler: Array.isArray(orijinal?.genelOzellikler) ? orijinal.genelOzellikler : [],
          teknik: typeof orijinal?.teknik === 'object' && orijinal.teknik !== null ? orijinal.teknik : {},
          varyantlar: Array.isArray(orijinal?.varyantlar) ? orijinal.varyantlar : []
        };

        setUrun(bulunan);
      });
  }, [id]);

  if (!urun) return <p style={{ textAlign: 'center' }}>Ürün bulunamadı.</p>;

  const kategori = urun.kategori || 'Kategori';
  const baslik = urun.baslik || 'Urun';

  return (
    <div className="urun-detay-container">
      <nav className="breadcrumb">
        <span onClick={() => navigate('/')}>Anasayfa</span> {'>'}
        <span onClick={() => navigate(`/urunler/${kategori}`)}>{kategori}</span> {'>'}
        <strong>{baslik}</strong>
      </nav>

      <button className="geri-buton" onClick={() => navigate(-1)}> ← Geri</button>

      <div className="urun-detay-kutu">
        <img src={urun.resim || '/images/bos-urun.jpg'} alt={urun.baslik} className="urun-resim" />

        <div className="urun-detay-bilgi">
          <h2>{urun.baslik}</h2>
          <p className="urun-aciklama">{urun.aciklama}</p>

          <div className="urun-kategori">
            <strong>Kategori:</strong> {urun.kategori} / {urun.altKategori}
          </div>

          {urun.detay && (
            <div className="urun-detay-text">
              <h4>Detaylı Açıklama:</h4>
              <p>{urun.detay}</p>
            </div>
          )}

          <div className="urun-ozellikler">
            <h4 onClick={() => setShowGenel(!showGenel)} style={{ cursor: 'pointer' }}>
              {showGenel ? '➖' : '➕'} Genel Özellikler
            </h4>
            {showGenel && (
              urun.genelOzellikler.length > 0 ? (
                <ul>
                  {urun.genelOzellikler.map((ozellik, i) => (
                    <li key={i}>✅ {ozellik}</li>
                  ))}
                </ul>
              ) : (
                <p style={{ fontStyle: 'italic', color: '#888' }}>Genel özellik belirtilmemiş.</p>
              )
            )}
          </div>

          <div className="urun-varyantlar">
            <h4 onClick={() => setShowVaryant(!showVaryant)} style={{ cursor: 'pointer' }}>
              {showVaryant ? '➖' : '➕'} Varyantlar
            </h4>
            {showVaryant && (
              urun.varyantlar.length > 0 ? (
                <table className="varyant-tablo">
                  <thead>
                    <tr>
                      <th>Model</th>
                      <th>Basınç</th>
                      <th>Kapasite</th>
                      <th>Motor (kW)</th>
                      <th>Motor (HP)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {urun.varyantlar.map((v, index) => (
                      <tr key={index}>
                        <td>{v.model}</td>
                        <td>{v.basinc}</td>
                        <td>{v.kapasite}</td>
                        <td>{v.motor_kw}</td>
                        <td>{v.motor_hp}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p style={{ fontStyle: 'italic', color: '#888' }}>Varyant bilgisi bulunmamaktadır.</p>
              )
            )}
          </div>

          <div className="urun-teknik">
            <h4>Teknik Özellikler:</h4>
            {urun.teknik && Object.keys(urun.teknik).length > 0 ? (
              <table className="teknik-tablo">
                <tbody>
                  {Object.entries(urun.teknik).map(([ozellik, deger], i) => (
                    <tr key={i}>
                      <td className="etiket" style={{ fontWeight: 'bold', padding: '6px', border: '1px solid #ddd' }}>{ozellik}</td>
                      <td style={{ padding: '6px', border: '1px solid #ddd' }}>{deger}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={{ fontStyle: 'italic', color: '#888' }}>Teknik bilgi bulunmamaktadır.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UrunDetay;
